import * as React from 'react';
import ReactDOM from 'react-dom';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {TrialBanner} from './trial-banner';

type OwnProps = {
    trialBannerMountId: string;
};
type Props = OwnProps & ContextRouter;

function TrialBannerPortalledComponent(props: Props) {
    const trialBannerMount = React.useMemo(() => {
        const mount = document.getElementById(props.trialBannerMountId);
        if (mount) {
            // Remove existing contents
            while (mount.firstChild) {
                mount.removeChild(mount.firstChild);
            }
        }

        return mount;
    }, [props.trialBannerMountId]);

    if (NutClientConfig.shouldShowTrialStatusBar) {
        if (!trialBannerMount) {
            throw new Error('Could not mount trial banner');
        }

        return ReactDOM.createPortal(<TrialBanner />, trialBannerMount);
    }

    return null;
}

// @ts-expect-error
export const TrialBannerPortalled = withRouter<OwnProps>(TrialBannerPortalledComponent);
